import { starterDeck } from "../builder";

export const EN_RU_GREETINGS = starterDeck({
  id: "en-ru-greetings-a1",
  name: "Приветствия и вежливость",
  name_en: "Greetings & Politeness",
  description: "Базовые фразы для знакомства и первого контакта.",
  description_en: "Basic phrases for meeting people and making first contact.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["Hello", "Привет"],
    ["Hi", "Привет (неформально)"],
    ["Good morning", "Доброе утро"],
    ["Good afternoon", "Добрый день"],
    ["Good evening", "Добрый вечер"],
    ["Good night", "Спокойной ночи"],
    ["Goodbye", "До свидания"],
    ["See you later", "Увидимся позже", "phrase"],
    ["Please", "Пожалуйста"],
    ["Thank you", "Спасибо", "phrase"],
    ["You're welcome", "Пожалуйста (в ответ)", "phrase"],
    ["Sorry", "Извини / Простите"],
    ["Excuse me", "Извините (привлечь внимание)", "phrase"],
    ["Yes", "Да"],
    ["No", "Нет"],
    ["How are you?", "Как дела?", "phrase"],
    ["I'm fine, thanks", "Всё хорошо, спасибо", "phrase"],
    ["Nice to meet you", "Приятно познакомиться", "phrase"],
    ["What's your name?", "Как тебя зовут?", "phrase"],
    ["My name is…", "Меня зовут…", "phrase"],
  ],
});

export const EN_RU_NUMBERS = starterDeck({
  id: "en-ru-numbers-a1",
  name: "Числа 1–20",
  name_en: "Numbers 1–20",
  description: "Числительные для базового счёта.",
  description_en: "Numerals for basic counting.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["one", "один"],
    ["two", "два"],
    ["three", "три"],
    ["four", "четыре"],
    ["five", "пять"],
    ["six", "шесть"],
    ["seven", "семь"],
    ["eight", "восемь"],
    ["nine", "девять"],
    ["ten", "десять"],
    ["eleven", "одиннадцать"],
    ["twelve", "двенадцать"],
    ["thirteen", "тринадцать"],
    ["fourteen", "четырнадцать"],
    ["fifteen", "пятнадцать"],
    ["sixteen", "шестнадцать"],
    ["seventeen", "семнадцать"],
    ["eighteen", "восемнадцать"],
    ["nineteen", "девятнадцать"],
    ["twenty", "двадцать"],
  ],
});

export const EN_RU_DAYS_MONTHS = starterDeck({
  id: "en-ru-days-months-a1",
  name: "Дни недели и месяцы",
  name_en: "Days of the Week & Months",
  description: "Дни недели и месяцы года.",
  description_en: "Days of the week and months of the year.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["Monday", "понедельник"],
    ["Tuesday", "вторник"],
    ["Wednesday", "среда"],
    ["Thursday", "четверг"],
    ["Friday", "пятница"],
    ["Saturday", "суббота"],
    ["Sunday", "воскресенье"],
    ["January", "январь"],
    ["February", "февраль"],
    ["March", "март"],
    ["April", "апрель"],
    ["May", "май"],
    ["June", "июнь"],
    ["July", "июль"],
    ["August", "август"],
    ["September", "сентябрь"],
    ["October", "октябрь"],
    ["November", "ноябрь"],
    ["December", "декабрь"],
  ],
});

export const EN_RU_FOOD = starterDeck({
  id: "en-ru-food-a1",
  name: "Еда и напитки",
  name_en: "Food & Drinks",
  description: "Самые частые слова из меню и магазина.",
  description_en: "The most common words from menus and grocery shopping.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "food",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["bread", "хлеб"],
    ["water", "вода"],
    ["milk", "молоко"],
    ["coffee", "кофе"],
    ["tea", "чай"],
    ["juice", "сок"],
    ["sugar", "сахар"],
    ["salt", "соль"],
    ["apple", "яблоко"],
    ["banana", "банан"],
    ["orange", "апельсин"],
    ["tomato", "помидор"],
    ["potato", "картофель"],
    ["chicken", "курица"],
    ["fish", "рыба"],
    ["rice", "рис"],
    ["pasta", "макароны"],
    ["cheese", "сыр"],
    ["egg", "яйцо"],
    ["soup", "суп"],
    ["breakfast", "завтрак"],
    ["lunch", "обед"],
    ["dinner", "ужин"],
    ["the bill, please", "счёт, пожалуйста", "phrase"],
  ],
});

export const EN_RU_TRAVEL = starterDeck({
  id: "en-ru-travel-a2",
  name: "Путешествия и аэропорт",
  name_en: "Travel & Airport",
  description: "Лексика для перемещения, аренды, контроля.",
  description_en: "Vocabulary for getting around, rentals, and checkpoints.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "travel",
  ageGroup: "adult",
  level: "A2",
  cards: [
    ["airport", "аэропорт"],
    ["passport", "паспорт"],
    ["ticket", "билет"],
    ["boarding pass", "посадочный талон", "phrase"],
    ["flight", "рейс"],
    ["gate", "выход на посадку"],
    ["luggage", "багаж"],
    ["customs", "таможня"],
    ["arrival", "прибытие"],
    ["departure", "вылет"],
    ["hotel", "отель"],
    ["room", "комната, номер"],
    ["reservation", "бронирование"],
    ["check-in", "регистрация / заселение"],
    ["check-out", "выписка / выезд"],
    ["map", "карта"],
    ["train", "поезд"],
    ["bus", "автобус"],
    ["taxi", "такси"],
    ["station", "станция, вокзал"],
    ["I'd like to book a room", "Я бы хотел забронировать номер", "phrase"],
    ["How much is it?", "Сколько это стоит?", "phrase"],
    ["Where is the metro?", "Где метро?", "phrase"],
  ],
});

export const EN_RU_CITY = starterDeck({
  id: "en-ru-city-a2",
  name: "Город и навигация",
  name_en: "City & Navigation",
  description: "Улицы, здания и вопросы о том, как пройти.",
  description_en: "Streets, buildings, and asking for directions.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "city",
  ageGroup: "adult",
  level: "A2",
  cards: [
    ["street", "улица"],
    ["avenue", "проспект"],
    ["square", "площадь"],
    ["bridge", "мост"],
    ["building", "здание"],
    ["shop", "магазин"],
    ["pharmacy", "аптека"],
    ["hospital", "больница"],
    ["bank", "банк"],
    ["post office", "почтовое отделение", "phrase"],
    ["church", "церковь"],
    ["museum", "музей"],
    ["park", "парк"],
    ["restaurant", "ресторан"],
    ["cafe", "кафе"],
    ["library", "библиотека"],
    ["school", "школа"],
    ["university", "университет"],
    ["traffic light", "светофор", "phrase"],
    ["turn left", "поверни налево", "phrase"],
    ["turn right", "поверни направо", "phrase"],
    ["go straight", "иди прямо", "phrase"],
  ],
});

export const EN_RU_EMOTIONS = starterDeck({
  id: "en-ru-emotions-a2",
  name: "Эмоции и состояния",
  name_en: "Emotions & States",
  description: "Слова для описания чувств и настроения.",
  description_en: "Words for describing feelings and mood.",
  sourceLang: "en",
  targetLang: "ru",
  topic: "emotions",
  ageGroup: "adult",
  level: "A2",
  cards: [
    ["happy", "счастливый"],
    ["sad", "грустный"],
    ["angry", "злой"],
    ["tired", "уставший"],
    ["bored", "скучающий"],
    ["excited", "взволнованный (приятно)"],
    ["scared", "испуганный"],
    ["surprised", "удивлённый"],
    ["nervous", "нервный"],
    ["calm", "спокойный"],
    ["proud", "гордый"],
    ["embarrassed", "смущённый"],
    ["jealous", "ревнивый"],
    ["lonely", "одинокий"],
    ["confident", "уверенный"],
    ["worried", "обеспокоенный"],
    ["grateful", "благодарный"],
    ["disappointed", "разочарованный"],
  ],
});
